<template>
  <div class="swipe">
    <van-swipe
      class="my-swipe"
      :height="180"
      :autoplay="3000"
      indicator-color="#C13C33"
      :stop-propagation="false"
    >
      <van-swipe-item v-for="(item,index) in Banner" :key="index" @click="toLink(item)">
        <img width="100%" :src="item.imgUrl" fit="cover" height="100%" />
      </van-swipe-item>
    </van-swipe>
  </div>
</template>
<script>
import utils from "@/utils/common";
export default {
  data() {
    return {};
  },
  props: {
    Banner: {
      default: [],
      type: Array
    }
  },
  methods: {
    toLink(item) {
      switch (item.linkType) {
        case 1:
          // this.$router.push({
          //   path: "/commoditydetails",
          //   query: { id: item.linkValue }
          // });
        var obj = {goodsId:parseInt(item.linkValue)};
        utils.jumpToNewPage({
            url: window.location.origin + "/h5user/commoditydetails?id=" + item.linkValue,
            noTitle: "0",
            action:{tm:"4030100",tp:obj}
        });

          break;
        case 2:
           this.$router.push({
            path: "/markentindex",
            query: { id: item.linkValue }
          });
          break;
        case 3:
          utils.jumpToNewPage({
            url:window.location.origin+'/h5user/brandindex?id='+item.linkValue,
            noTitle:'1',
             action:{tm:"4090100",tp:{branchId:parseInt(item.linkValue)}}
          })
          break;
        case 4:
          if (item.linkValue) {
            utils.jumpUrl(item.linkValue);
          }
          break;
      }
      // switch (item.linkType) {
      //   case 1:
      //     this.$router.push({
      //       path: "/iconDetail",
      //       query: { iconid: item.id }
      //     })
      //     break;
      //   case 2:
      //     this.$router.push({
      //       path: "/markentindex",
      //       query: { id: item.linkValue }
      //     });
      //     break;
      //   case 3:
      //     this.$router.push({
      //       path: "/brandindex",
      //       query: { id: item.linkValue }
      //     });
      //     break;
      //   case 4:
      //     this.$router.push({
      //       path: "/commoditydetails",
      //       query: { id: item.linkValue }
      //     });
      //     break;
      //   case 6:
      //     if (item.linkValue) {
      //       utils.jumpUrl(item.linkValue);
      //     }
      //     break;
      // }
    }
  }
};
</script>
<style lang="less" scoped>
.swipe {
  margin-top: -120px;
  padding: 0 30px;
  text-align: center;
  img {
    border-radius: 20px;
  }
}
</style>